<template>
  <el-dialog title="选择物料" :visible.sync="visibleInner" width="1080px" append-to-body @close="handleClose">
    <el-form :inline="true" :model="query">
      <el-form-item label="物料编码"><el-input v-model="query.materialCode" size="small" clearable /></el-form-item>
      <el-form-item label="物料名称"><el-input v-model="query.materialName" size="small" clearable /></el-form-item>
      <el-form-item><el-button size="small" type="primary" @click="search">查询</el-button></el-form-item>
    </el-form>
    <el-table
      ref="table"
      :data="list"
      border
      v-loading="loading"
      height="420"
      row-key="materialId"
      :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
      @selection-change="handleSelectionChange"
    >
      <el-table-column
        v-if="multiple"
        type="selection"
        width="55"
        align="center"
        :reserve-selection="true"
      />
      <el-table-column prop="materialCode" label="物料编码" width="150" />
      <el-table-column prop="materialName" label="物料名称" min-width="180" />
      <el-table-column prop="specs" label="规格型号" min-width="140" />
      <el-table-column prop="quantity" label="库存数量" width="110" align="right" header-align="center">
        <template slot-scope="scope">{{ formatQty(scope.row.quantity) }}</template>
      </el-table-column>
      <el-table-column prop="usableQuantity" label="可用数量" width="110" align="right" header-align="center">
        <template slot-scope="scope">{{ formatQty(scope.row.usableQuantity) }}</template>
      </el-table-column>
      <el-table-column v-if="!multiple" label="操作" width="80" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="choose(scope.row)">选择</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div v-if="multiple" class="selected-tip">已选 {{ selectedCount }} 条</div>
    <el-pagination
      :current-page="pageIndex"
      :page-size="pageSize"
      :total="total"
      layout="total, prev, pager, next"
      @current-change="pageChange"
    />
    <span v-if="multiple" slot="footer" class="dialog-footer">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="confirmMultiple">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { listMaterial } from '../api/base/material'

export default {
  name: 'MaterialSelector',
  props: {
    visible: { type: Boolean, default: false },
    multiple: { type: Boolean, default: true }
  },
  data() {
    return {
      visibleInner: false,
      query: { materialCode: '', materialName: '' },
      list: [],
      loading: false,
      pageIndex: 1,
      pageSize: 20,
      total: 0,
      selectedMap: {},
      isRestoring: false
    }
  },
  computed: {
    selectedCount() {
      return Object.keys(this.selectedMap).length
    }
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.visibleInner = !!val
        if (val) {
          this.resetSelection()
          this.pageIndex = 1
          this.loadList()
        }
      }
    }
  },
  methods: {
    formatQty(val) {
      if (val === null || val === undefined || val === '') {
        return '0'
      }
      const n = Number(val)
      if (Number.isNaN(n)) {
        return '0'
      }
      return n.toLocaleString('zh-CN', { minimumFractionDigits: 0, maximumFractionDigits: 6 })
    },
    resetSelection() {
      this.selectedMap = {}
      this.$nextTick(() => {
        if (this.$refs.table) {
          this.$refs.table.clearSelection()
        }
      })
    },
    loadList() {
      this.loading = true
      listMaterial({
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        materialCode: this.query.materialCode,
        materialName: this.query.materialName,
        includeInventoryQty: true
      }).then(res => {
        this.loading = false
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
        if (this.multiple) {
          this.restorePageSelection()
        }
      }).catch(() => {
        this.loading = false
      })
    },
    search() {
      this.pageIndex = 1
      if (this.multiple) {
        this.resetSelection()
      }
      this.loadList()
    },
    restorePageSelection() {
      this.isRestoring = true
      this.$nextTick(() => {
        const table = this.$refs.table
        if (!table) {
          this.isRestoring = false
          return
        }
        this.list.forEach(row => {
          if (row.materialId && this.selectedMap[row.materialId]) {
            table.toggleRowSelection(row, true)
          }
        })
        this.isRestoring = false
      })
    },
    handleSelectionChange(selection) {
      if (!this.multiple || this.isRestoring) return
      const currentPageIds = this.list.map(row => row.materialId).filter(Boolean)
      const selectedIds = selection.map(row => row.materialId)
      currentPageIds.forEach(id => {
        if (selectedIds.indexOf(id) === -1) {
          this.$delete(this.selectedMap, id)
        }
      })
      selection.forEach(row => {
        if (row.materialId) {
          this.$set(this.selectedMap, row.materialId, row)
        }
      })
    },
    pageChange(val) {
      this.pageIndex = val
      this.loadList()
    },
    choose(row) {
      this.$emit('select', row)
      this.visibleInner = false
      this.$emit('update:visible', false)
    },
    confirmMultiple() {
      const rows = Object.values(this.selectedMap)
      if (!rows.length) {
        this.$message.warning('请至少选择一条物料')
        return
      }
      this.$emit('select-multiple', rows)
      this.visibleInner = false
      this.$emit('update:visible', false)
    },
    cancel() {
      this.visibleInner = false
      this.$emit('update:visible', false)
    },
    handleClose() {
      this.$emit('update:visible', false)
    }
  }
}
</script>

<style scoped>
.selected-tip {
  margin: 8px 0 4px;
  font-size: 13px;
  color: #606266;
}
</style>
